/**
 *
 * ShiftDetailCardApplications
 *
 */

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Collapse from '@mui/material/Collapse';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ApplicationsIcon from '@mui/icons-material/EmojiPeople';

import messages from './messages';

type ShiftDetailCardApplicationsProps = {
  assignedApplicationCount: number;
  unassignedApplicationCount: number;
};

export const ShiftDetailCardApplications = (
  props: ShiftDetailCardApplicationsProps
) => {
  const intl = useIntl();
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpand = () => setExpanded(!expanded);

  const { assignedApplicationCount, unassignedApplicationCount } = props;
  const totalApplications =
    assignedApplicationCount + unassignedApplicationCount;
  return (
    <Card>
      <CardHeader
        avatar={<ApplicationsIcon />}
        title={<FormattedMessage {...messages.header} />}
        subheader={
          <FormattedMessage
            {...messages.total}
            values={{ totalApplications: totalApplications.toString() }}
          />
        }
        action={
          <IconButton onClick={toggleExpand} color="inherit" size="large">
            <ExpandMoreIcon
              style={{
                transform: `rotate(${expanded ? '180' : '0'}deg)`,
                transition: 'transform 300ms',
              }}
            />
          </IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider />
        <CardContent style={{ padding: 0 }}>
          <List>
            <ListItem>
              <ListItemText
                primary={assignedApplicationCount.toString()}
                secondary={intl.formatMessage(messages.assignedApplications)}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={unassignedApplicationCount.toString()}
                secondary={intl.formatMessage(messages.unassignedApplications)}
              />
            </ListItem>
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ShiftDetailCardApplications;
